import { render, staticRenderFns } from "./FooterDataTable.vue?vue&type=template&id=ab8945ea&scoped=true"
import script from "./FooterDataTable.vue?vue&type=script&lang=js"
export * from "./FooterDataTable.vue?vue&type=script&lang=js"
import style0 from "./FooterDataTable.vue?vue&type=style&index=0&id=ab8945ea&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ab8945ea",
  null
  
)

export default component.exports